/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Error_Uploadnda2Inputs */

const en_coinvestments_error_uploadnda2 = /** @type {(inputs: Coinvestments_Error_Uploadnda2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to upload NDA document`)
};

/**
* | output |
* | --- |
* | "Failed to upload NDA document" |
*
* @param {Coinvestments_Error_Uploadnda2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_error_uploadnda2 = /** @type {((inputs?: Coinvestments_Error_Uploadnda2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Error_Uploadnda2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_error_uploadnda2(inputs)
});
export { coinvestments_error_uploadnda2 as "coInvestments_error_uploadNda" }